import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "components/common/Button";
import { Select } from "components/common/Select";

interface GroupSelectionStepV3Props {
  selectedGroupName: string;
  onGroupNameChange: (name: string) => void;
  groupOptions: string[];
  onStartAdding: () => void;
}

export const GroupSelectionStepV3 = ({
  selectedGroupName,
  onGroupNameChange,
  groupOptions,
  onStartAdding,
}: GroupSelectionStepV3Props) => {
  const { t } = useTranslation();

  const isGroupSelected = selectedGroupName.trim().length > 0;

  const selectOptions = useMemo(
    () => groupOptions.map((option) => ({ value: option, label: option })),
    [groupOptions],
  );

  return (
    <div className="flex flex-col gap-3 flex-1">
      <p className="text-sm text-gray-500">
        {t("smartSurveyor.elementsCreation.chooseGroup")}
      </p>
      <div className="space-y-1.5">
        <span className="text-sm text-gray-700 font-medium">
          {t("smartSurveyor.groupInspector.groupLabel")}
        </span>
        <Select
          multiline
          value={selectedGroupName}
          onChange={onGroupNameChange}
          options={selectOptions}
          placeholder={t("smartSurveyor.elementsCreation.groupPlaceholder")}
        />
      </div>
      <Button
        variant="primary"
        className="w-full"
        disabled={!isGroupSelected}
        onClick={onStartAdding}
      >
        {t("smartSurveyor.elementsCreation.startAdding")}
      </Button>
    </div>
  );
};
